import type { Moment } from 'moment';

import moment from './moment';

const momentPrefix = '#moment#';

export const serialize = (element: any): any => {
  if (!element) {
    return element;
  }
  if (Array.isArray(element)) {
    return element.map((value) => serialize(value));
  }
  if (element instanceof moment) {
    return `${momentPrefix}${(element as Moment).toISOString()}`;
  }
  if (typeof element === 'object') {
    const newElement: any = {};
    Object.keys(element).forEach((key) => {
      newElement[key] = serialize(element[key]);
    });
    return newElement;
  }
  return element;
};

export const deserialize = (element: any): any => {
  if (!element) {
    return element;
  }
  if (Array.isArray(element)) {
    return element.map((value) => deserialize(value));
  }
  if (typeof element === 'string' && element.startsWith(momentPrefix)) {
    return moment(element.substring(momentPrefix.length));
  }
  if (typeof element === 'object') {
    const newElement: any = {};
    Object.keys(element).forEach((key) => {
      newElement[key] = deserialize(element[key]);
    });
    return newElement;
  }
  return element;
};
